import type { BadgeDefinition } from '../types/gamification.types';

export const BADGE_DEFINITIONS: Record<string, BadgeDefinition> = {
  profile_complete: {
    id: 'profile_complete',
    name: 'Profil Complet',
    description: 'Vous avez complété toutes vos informations prestataire.',
    rarity: 'common',
    celebrationType: 'badge',
    icon: 'UserCircleIcon',
  },
  account_validated: {
    id: 'account_validated',
    name: 'Compte Validé',
    description: 'Votre compte a été validé par un administrateur.',
    rarity: 'rare',
    celebrationType: 'celebration',
    icon: 'ShieldCheckIcon',
  },
  first_invoice: {
    id: 'first_invoice',
    name: 'Première Facture',
    description: 'Vous avez soumis votre toute première facture.',
    rarity: 'common',
    celebrationType: 'badge',
    icon: 'DocumentTextIcon',
  },
  first_payment: {
    id: 'first_payment',
    name: 'Premier Paiement',
    description: 'Votre première facture a été payée.',
    rarity: 'rare',
    celebrationType: 'celebration',
    icon: 'BanknotesIcon',
  },
  invoices_5: {
    id: 'invoices_5',
    name: 'Habitué',
    description: 'Vous avez soumis 5 factures.',
    rarity: 'common',
    celebrationType: 'badge',
    icon: 'DocumentDuplicateIcon',
  },
  invoices_10: {
    id: 'invoices_10',
    name: 'Pro',
    description: 'Vous avez soumis 10 factures.',
    rarity: 'rare',
    celebrationType: 'badge',
    icon: 'StarIcon',
  },
  invoices_25: {
    id: 'invoices_25',
    name: 'Expert',
    description: 'Vous avez soumis 25 factures.',
    rarity: 'epic',
    celebrationType: 'celebration',
    icon: 'TrophyIcon',
  },
  revenue_1000: {
    id: 'revenue_1000',
    name: 'Premier Millier',
    description: 'Vous avez cumulé 1 000 \u20AC de paiements.',
    rarity: 'common',
    celebrationType: 'badge',
    icon: 'CurrencyEuroIcon',
  },
  revenue_5000: {
    id: 'revenue_5000',
    name: 'Croissance',
    description: 'Vous avez cumulé 5 000 \u20AC de paiements.',
    rarity: 'rare',
    celebrationType: 'badge',
    icon: 'ArrowTrendingUpIcon',
  },
  revenue_10000: {
    id: 'revenue_10000',
    name: 'Décollage',
    description: 'Vous avez cumulé 10 000 \u20AC de paiements.',
    rarity: 'epic',
    celebrationType: 'celebration',
    icon: 'RocketLaunchIcon',
  },
};

export const RARITY_COLORS = {
  common: {
    primary: '#3B82F6',
    secondary: '#60A5FA',
    bg: 'bg-blue-500',
    bgLight: 'bg-blue-50',
    text: 'text-blue-600',
    border: 'border-blue-200',
    glow: 'rgba(59, 130, 246, 0.5)',
    gradient: 'from-blue-500 to-blue-600',
    particle: '#93C5FD',
  },
  rare: {
    primary: '#8B5CF6',
    secondary: '#A78BFA',
    bg: 'bg-violet-500',
    bgLight: 'bg-violet-50',
    text: 'text-violet-600',
    border: 'border-violet-200',
    glow: 'rgba(139, 92, 246, 0.5)',
    gradient: 'from-violet-500 to-purple-600',
    particle: '#C4B5FD',
  },
  epic: {
    primary: '#F59E0B',
    secondary: '#FBBF24',
    bg: 'bg-amber-500',
    bgLight: 'bg-amber-50',
    text: 'text-amber-600',
    border: 'border-amber-200',
    glow: 'rgba(245, 158, 11, 0.5)',
    gradient: 'from-amber-500 to-orange-500',
    particle: '#FDE68A',
  },
} as const;
